import React from 'react'
import classNames from 'classnames'
import ShipItems from './ShipItems'
import ShipOrderDetails from './ShipOrderDetails'


class ShipContent extends React.Component {
    render() {
        const {item, ...rest} = this.props
        const {isShipped} = item

        const printContentClassName = classNames({
            ShipContent: true,
            'mt-3': true,
            Disabled: isShipped
        })

        return (
            <div className={printContentClassName}>
                <ShipOrderDetails {...rest} item={item}/>
                <ShipItems {...rest} item={item}/>
            </div>
        )
    }
}

export default ShipContent
